import { injectable } from 'inversify';
import MessengerService from './messengerService';
import { Message } from './message';

@injectable()
class PostMessengerService implements MessengerService {
  appointmentScheduled(): void {
    this.postMessage(Message.AppointmentScheduled);
  }

  cancelScheduling(): void {
    this.postMessage(Message.CancelScheduling);
  }

  finishedScheduling(): void {
    this.postMessage(Message.FinishedScheduling);
  }

  private postMessage(event: string): void {
    window.postMessage({
      source: 'mchs-scheduling',
      event: event,
    });
  }
}

export default PostMessengerService;
